import aT from '../const/action-type'

export default (data) => ({ type: aT.SET_ORG, data })
